import styled from 'styled-components';
import { Form } from 'react-bootstrap';

const Label = styled(Form.Label)`
  && {
    color: ${(prop) => prop.theme.colors.comet};
    font-weight: 500;
    align-self: center;
    font-size: 14px;
    line-height: 1.3em;
  }
`;

export default Label;
